import styled from 'styled-components';
const WrapperContainer = styled.div`
  max-width: 1224px;
  margin:0 auto;
`;

const Wrapper = ({children}:any) => {
    return (
        <WrapperContainer>
            {children}
        </WrapperContainer>
    );
}

export default Wrapper;
